export const en = {
  // Global
  lang_name: 'English',
  lang_code: 'en',
  platform_name: 'Sovereign IQ',
  platform_subtitle: 'Intelligence Platform',
  confidential: 'Confidential',
  loading: 'Loading...',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  search: 'Search',
  submit: 'Submit',
  back: 'Back',
  next: 'Next',
  close: 'Close',
  download: 'Download',
  export_csv: 'Export CSV',
  generating: 'Generating...',
  generated: 'Generated',
  not_generated: 'Not generated yet',
  success: 'Success',
  error: 'Error',
  
  // Navigation
  nav_home: 'Main Website',
  nav_dashboard: 'Dashboard',
  nav_countries: 'Countries',
  nav_configuration: 'Configuration',
  nav_generator: 'Generator',
  nav_compare: 'Compare',
  nav_documents: 'Documents',
  nav_use_cases: 'Use Cases',
  nav_user_management: 'User Management',
  nav_pricing_model: 'Pricing Model',
  nav_ai_budget: 'AI Budget',
  nav_collapse: 'Collapse',
  nav_logout: 'Logout',

  // Landing Page
  landing_hero_title: 'Sovereign Intelligence',
  landing_hero_subtitle: 'AI-powered country risk analysis and investment-grade blueprints for global expansion',
  landing_cta: 'Get Started',
  landing_login: 'Login',
  landing_features_title: 'Platform Capabilities',
  landing_doc: 'Documentation',
  landing_use_cases: 'Use Cases',
  landing_sources: 'Sources',
  landing_pricing: 'Pricing',

  // Login/Register
  login_title: 'Sign In',
  login_subtitle: 'Access your intelligence dashboard',
  login_email: 'Email Address',
  login_password: 'Password',
  login_btn: 'Sign In',
  login_register_link: 'Create an account',
  register_title: 'Register',
  register_subtitle: 'Join Sovereign IQ Intelligence Platform',
  register_full_name: 'Full Name',
  register_company: 'Company',
  register_location: 'Location (City, Country)',
  register_areas: 'Areas of Interest',
  register_btn: 'Register',
  register_pending: 'Your registration is pending admin approval.',
  register_login_link: 'Already have an account? Sign in',

  // Dashboard
  dash_title: 'Country Intelligence Dashboard',
  dash_subtitle: 'Real-time sovereign risk monitoring and economic intelligence',
  dash_intelligence_feed: 'Intelligence Feed',
  dash_key_targets: 'Key Intelligence Targets',
  dash_system_status: 'System Status',
  dash_economic_forecasts: 'IMF Economic Forecasts',
  dash_data_sources: 'Data Source Monitor',
  dash_trend_chart: 'Historical Trend',
  dash_world_map: 'Global Risk Map',

  // Countries
  countries_title: 'Intelligence Targets',
  countries_subtitle: 'Your country intelligence portfolio',
  countries_add: 'Add Territory',
  countries_search: 'Search countries...',
  countries_no_results: 'No countries found',
  countries_sections: 'sections',
  countries_remaining: 'Reports Remaining',
  countries_pdf: 'PDF Report',
  countries_view: 'View Blueprint',
  countries_delete_confirm: 'Delete this country and all its data?',

  // Blueprint Config
  config_title: 'Blueprint Configuration',
  config_subtitle: 'Configure your country intelligence blueprint parameters',
  config_country: 'Select Country',
  config_sector: 'Select Sector',
  config_focus: 'Focus Areas',
  config_generate: 'Generate Blueprint',

  // Generator
  gen_title: 'Section Generator',
  gen_subtitle: 'Synthesizing multi-modal data streams for high-fidelity regional assessment. Review and generate intelligence blocks.',
  gen_select_country: 'Select country',
  gen_generate_all: 'Generate All (Text + Illustrations)',
  gen_generate: 'Generate',
  gen_regenerate: 'Regenerate',
  gen_generate_illustration: 'Generate Illustration',
  gen_regenerate_illustration: 'Regenerate Illustration',
  gen_preview: 'Preview',
  gen_complete: 'Complete',
  gen_draft: 'Draft',
  gen_illustrated: 'Illustrated',
  gen_creating_illustration: 'Creating illustration...',
  gen_generating_synthesis: 'Generating Synthesis...',
  gen_regenerations_used: 'regenerations used',
  gen_regional_intelligence: 'Regional Intelligence',
  gen_updated: 'Updated',
  gen_outlook: 'Outlook',
  gen_additional_sections: 'Additional sections available',
  gen_select_prompt: 'Select a Country',
  gen_select_prompt_desc: 'Choose a country from the dropdown above to start generating intelligence sections.',

  // Blueprint View
  bp_sections_generated: 'Sections Generated',
  bp_economic_trends: 'Economic Trends',
  bp_world_bank_data: 'World Bank Data',
  bp_ai_studio: 'AI Studio',
  bp_quick_export: 'Quick Export',
  bp_pdf_report: 'PDF Report',
  bp_generate_audio: 'Generate Audio Overview',
  bp_regenerate_audio: 'Regenerate Audio',
  bp_generate_infographic: 'Generate Infographic',
  bp_regenerate_infographic: 'Regenerate Infographic',
  bp_generate_references: 'Generate References',
  bp_regenerate_references: 'Regenerate References',
  bp_audio_overview: 'Audio Overview',
  bp_infographic: 'Investment Infographic',
  bp_references: 'Sources & References',

  // Section Names
  sec_country_snapshot: 'Macro-Economic Indicators',
  sec_executive_summary: 'Executive Summary',
  sec_pestle_analysis: 'Geopolitical Risk',
  sec_market_opportunity: 'Market Opportunity',
  sec_government_capacity: 'Government Capacity',
  sec_competitive_landscape: 'Competitive Landscape',
  sec_business_model: 'Business Model',
  sec_risk_analysis: 'Risk Analysis',
  sec_financial_projections: 'Regulatory Framework',
  sec_sovereign_risk: 'Sovereign Risk',
  sec_social_impact: 'Workforce & Human Capital',
  sec_governance: 'Governance',

  // Admin
  admin_title: 'User Management',
  admin_users: 'Users',
  admin_approve: 'Approve',
  admin_reject: 'Reject',
  admin_pending: 'Pending',
  admin_active: 'Active',
  admin_gift_reports: 'Gift Reports',
  admin_email_config: 'Email Configuration',
  admin_bcc_email: 'BCC Email',

  // Pricing
  pricing_title: 'Pricing',
  pricing_per_report: 'Per Report',
  pricing_buy_report: 'Buy Report',
  pricing_coupon: 'Coupon Code',
  pricing_redeem: 'Redeem',
  pricing_lucky: 'Be Lucky',
  pricing_request_free: 'Request Free Report',

  // Budget
  budget_title: 'AI Budget Monitor',
  budget_available: 'Available Balance',
  budget_spent: 'Total Spent',
  budget_generations: 'Total Generations',

  // Comparison
  compare_title: 'Country Comparison',
  compare_subtitle: 'Compare economic indicators across countries',
  compare_select: 'Select countries to compare',

  // Payment
  payment_success: 'Payment Successful!',
  payment_report_added: 'Your report has been added to your account.',
};
